import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
const BROCHURE_URL = 'https://ss-usa.s3.amazonaws.com/c/308482149/media/18876a2c91699a5ad48476891281503/TwentyMileHouse2027.pdf';
export function BrochureViewer() {
  return <section className="mx-auto mt-12 max-w-5xl px-6" aria-labelledby="brochure-heading" data-id="element-64" data-mp="3qir6wa6eelq5">
      <div className="text-center" data-id="element-65" data-mp="3lm0mjank93yx">
        <h2 id="brochure-heading" className="font-display text-3xl text-ink" data-id="element-66" data-mp="3liwbbtboh7yr">
          Our pricing &amp; <em className="text-gold" data-id="element-67" data-mp="2xtbubfz34ks4">packages</em> guide
        </h2>
        <p className="mx-auto mt-2 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-68" data-mp="2sxmoww0dw9nw">
          Flip through our packages and spaces ahead of your tour.
        </p>
      </div>

      {/* Inline viewer on larger screens; phones handle embedded PDFs poorly. */}
      <div className="mt-8 hidden border border-ink/10 md:block" data-id="element-69" data-mp="2f4din47qg49l">
        <iframe src={`${BROCHURE_URL}#view=FitH`} title="Twenty Mile House 2027 brochure" className="h-[80vh] max-h-[900px] min-h-[600px] w-full" loading="lazy" data-id="element-70" data-mp="2f2katlldve00" />
      </div>

      <div className="mt-6 flex justify-center" data-id="element-71" data-mp="s8oxs13mn004">
        <a href={BROCHURE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-logo px-7 py-3 font-sans text-sm text-white transition-opacity duration-150 hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-logo" data-id="element-72" data-mp="s7du01a6ls90">
          View the full brochure
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="9bxevsrzymwl" />
        </a>
      </div>
    </section>;
}